/**
 * EU has one additional footer link "Contact Us".
 */ export var RETAILER_SHOW_FOOTER_CONTACT_US = 'RETAILER_SHOW_FOOTER_CONTACT_US';
